
export default {
  SET_COMMENTS: (state, payload) => state.comments = payload,
}